import { FC, useEffect, useState } from 'react'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { DayOfWeekEnum } from '../../../../enums/DayOfWeekEnum'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'
import { SelectModel } from '../../../models/SelectModel'
import StudentReportApi from '../../../../infrastructure/api/StudentReportApi'
import { IStudentReportModel } from '../../../../models/responses/StudentReportModel'

type Props = {
    onClickItem: (itemId: any, itemName: string, type: string) => void
    refresh: number
    trainerList: SelectModel[]
}

const StudentReportListModal: FC<Props> = ({ onClickItem, refresh, trainerList }) => {

    const [pageNumber, setPageNumber] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [searchText, setSearchText] = useState('')
    const [sort, setSort] = useState('createdAt_desc')
    const [studentReports, setStudentReports] = useState<PagedResponseModel<IStudentReportModel[]>>()

    async function init() {
        const paginationFilter: IPaginationFilter = {
            page: pageNumber,
            size: pageSize,
            orderBy: sort,
            search: searchText
        }

        var response = await StudentReportApi.GetStudentReports(paginationFilter)
        setStudentReports(response.data)
    }

    useEffect(() => {
        init()
    }, [refresh, pageNumber, pageSize, searchText, sort])

    return (
        <>
            <div className='row'>
                <GenericTable
                    title='Student Reports'
                    data={studentReports?.items}
                    currentTotalRecords={studentReports?.totalRecords!!}
                    currentPageNumber={studentReports?.pageNumber!!}
                    columns={[
                        {
                            label: '#',
                            name: '#',
                            options: {
                                customBodyRenderLite: (dataIndex) => {
                                    return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
                                },
                                sort: false,
                                viewColumns: false
                            },
                        },
                        {
                            label: "Date", name: "createdAt", options: {
                                customBodyRender: (value) => {
                                    return <>{value}</>
                                }
                            }
                        },
                        {
                            label: "Start Date", name: "startDate", options: {
                                customBodyRender: (value) => {
                                    return <>{value}</>
                                }
                            }
                        },
                        {
                            label: "End Date", name: "endDate", options: {
                                customBodyRender: (value) => {
                                    return <>{value}</>
                                }
                            }
                        },
                        {
                            label: "Status", name: "statusInfo", options: {
                                customBodyRenderLite: (dataIndex) => {
                                    switch (studentReports?.items[dataIndex].status) {
                                        case 1:
                                            return <><span className='text-primary'><span className='spinner-border spinner-border-sm align-middle ms-2'></span>Preparing</span></>
                                            break;
                                        case 2:
                                            return <><span className='text-success'>Completed</span></>
                                            break;
                                        case 3:
                                            return <><span className='text-warning'>Cancelled</span></>
                                            break;
                                        default:
                                            break;
                                    }
                                }
                            }
                        },
                        {
                            label: "Completed Date", name: "modifiedAt", options: {
                                customBodyRenderLite: (dataIndex) => {
                                    return <>{studentReports?.items[dataIndex].status == 1 ? "" : studentReports?.items[dataIndex].modifiedAt}</>
                                }
                            }
                        },
                        {
                            label: '#',
                            name: 'Id',
                            options: {
                                customHeadLabelRender: (options) => {
                                    return (
                                        <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                                    )
                                },
                                customBodyRenderLite: (dataIndex) => {
                                    return (
                                        <TableHelperButtons
                                            itemId={studentReports?.items[dataIndex]?.id!!}
                                            itemParam={studentReports?.items[dataIndex]?.createdAt}
                                            types={[TableHelperButtonEnum.View]}
                                            onClickItem={onClickItem}
                                        />
                                    )
                                },
                                filter: false,
                                sort: false,
                                viewColumns: false,
                            },
                        },
                    ]}
                    customOptions={{
                        search: false,
                        sort: false,
                        customTableBodyFooterRender: (opts) => {
                            return <div></div>
                        },
                    }}
                    setPageNumber={setPageNumber}
                    setPageSize={setPageSize}
                    setSearchText={setSearchText}
                    setSort={setSort}

                />
            </div>
        </>
    )
}

export { StudentReportListModal }
